import { delay, fork, put, takeLatest } from "redux-saga/effects";
import { LOCATION_CHANGE } from "react-router-redux";

import { fetchMarketingBarsRoutine } from "../marketingBars";

function* onLocationChange() {
  yield delay(200);

  yield put(fetchMarketingBarsRoutine());
}

function* watchLocationChange() {
  yield takeLatest(LOCATION_CHANGE, onLocationChange);
}

export default [fork(watchLocationChange)];
